import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<label class=tzr-field><span></span><select><option value>`),
  _tmpl$2 = /*#__PURE__*/_$template(`<label class=tzr-field><span></span><span class=tzr-filter-range><input type=date>–<input type=date>`),
  _tmpl$3 = /*#__PURE__*/_$template(`<label class=tzr-field><span></span><input>`),
  _tmpl$4 = /*#__PURE__*/_$template(`<option>`),
  _tmpl$5 = /*#__PURE__*/_$template(`<div class=tzr-filter-scrim>`),
  _tmpl$6 = /*#__PURE__*/_$template(`<div class=tzr-filter-pop><button type=button class=tzr-filter-adv> →`),
  _tmpl$7 = /*#__PURE__*/_$template(`<div class=tzr-filter-drawer><header class=tzr-read-header><div class=tzr-read-title></div><button type=button class=tzr-x>✕</button></header><div class=tzr-filter-stack></div><footer class=tzr-read-actions><button type=button class=tzr-btn></button><button type=button class="tzr-btn primary">OK`),
  _tmpl$8 = /*#__PURE__*/_$template(`<div class=tzr-filter><button type=button class=tzr-btn>`),
  _tmpl$9 = /*#__PURE__*/_$template(`<div class=tzr-chips-row><button type=button class=tzr-chips-clear>`),
  _tmpl$0 = /*#__PURE__*/_$template(`<span class=tzr-chip-active><button type=button>✕`);
/**
 * The filter surface, ported from bosy's meleFilter (design: mo-filterpop / mo-chips):
 * a `Filter · N` toolbar button opening the QUICK popover (items flagged quick + the
 * "all filters →" link), the ADVANCED drawer with every item, and the active-filter
 * CHIPS row as a separate placement. The module owns the item declarations, values and
 * query compilation (`filterItems`/`setFilter`/`filterQuery`); this file only renders.
 */

import { For, Show, createSignal } from 'solid-js';
import { useWorkflow } from 'mmodSolidWorkflow';
import { Drawer } from 'mmodSolidModule/components';
function FilterControl(props) {
  const {
    store,
    module: m,
    tr
  } = useWorkflow();
  const item = () => props.item;
  const value = () => store.filters[item().key];
  const range = () => value() || {};
  return _$createComponent(Show, {
    get when() {
      return item().kind === 'select';
    },
    get fallback() {
      return _$createComponent(Show, {
        get when() {
          return item().kind === 'range';
        },
        get fallback() {
          return (() => {
            var _el$1 = _tmpl$3(),
              _el$10 = _el$1.firstChild,
              _el$11 = _el$10.nextSibling;
            _$insert(_el$10, () => tr(item().key));
            _el$11.addEventListener("change", e => m.setFilter(item().key, e.currentTarget.value || undefined));
            _$effect(() => {
              var _value;
              return _el$11.value = _.toString((_value = value()) !== null && _value !== void 0 ? _value : '');
            });
            return _el$1;
          })();
        },
        get children() {
          var _el$5 = _tmpl$2(),
            _el$6 = _el$5.firstChild,
            _el$7 = _el$6.nextSibling,
            _el$8 = _el$7.firstChild,
            _el$9 = _el$8.nextSibling,
            _el$0 = _el$9.nextSibling;
          _$insert(_el$6, () => tr(item().key));
          _el$8.addEventListener("change", e => m.setFilter(item().key, {
            ...range(),
            from: e.currentTarget.value || undefined
          }));
          _el$0.addEventListener("change", e => m.setFilter(item().key, {
            ...range(),
            to: e.currentTarget.value || undefined
          }));
          _$effect(() => _el$8.value = range().from || '');
          _$effect(() => _el$0.value = range().to || '');
          return _el$5;
        }
      });
    },
    get children() {
      var _el$ = _tmpl$(),
        _el$2 = _el$.firstChild,
        _el$3 = _el$2.nextSibling,
        _el$4 = _el$3.firstChild;
      _$insert(_el$2, () => tr(item().key));
      _el$3.addEventListener("change", e => m.setFilter(item().key, e.currentTarget.value || undefined));
      _$insert(_el$4, () => tr('list.All'));
      _$insert(_el$3, _$createComponent(For, {
        get each() {
          return item().options || [];
        },
        children: option => (() => {
          var _el$12 = _tmpl$4();
          _$insert(_el$12, () => option.label);
          _$effect(() => _el$12.value = option.value);
          return _el$12;
        })()
      }), null);
      _$effect(() => {
        var _value2;
        return _el$3.value = _.toString((_value2 = value()) !== null && _value2 !== void 0 ? _value2 : '');
      });
      return _el$;
    }
  });
}

/** The `Filter · N` button + quick popover + advanced drawer. */
export function FilterButton() {
  const {
    module: m,
    tr
  } = useWorkflow();
  const [pop, setPop] = createSignal(false);
  const [adv, setAdv] = createSignal(false);
  const count = () => m.activeFilters().length;
  const openAdvanced = () => {
    setPop(false);
    m.loadDevices(); // the device dropdown reads the register fresh
    setAdv(true);
  };
  return (() => {
    var _el$13 = _tmpl$8(),
      _el$14 = _el$13.firstChild;
    _el$14.$$click = () => setPop(v => !v);
    _$insert(_el$14, () => tr('filter.Button'), null);
    _$insert(_el$14, (() => {
      var _c$ = _$memo(() => count() > 0);
      return () => _c$() ? ` · ${count()}` : '';
    })(), null);
    _$insert(_el$13, _$createComponent(Show, {
      get when() {
        return pop();
      },
      get children() {
        return [(() => {
          var _el$15 = _tmpl$5();
          _el$15.$$click = () => setPop(false);
          return _el$15;
        })(), (() => {
          var _el$16 = _tmpl$6(),
            _el$17 = _el$16.firstChild,
            _el$18 = _el$17.firstChild;
          _$insert(_el$16, _$createComponent(For, {
            get each() {
              return m.filterItems().filter(item => item.quick);
            },
            children: item => _$createComponent(FilterControl, {
              item: item
            })
          }), _el$17);
          _el$17.$$click = openAdvanced;
          _$insert(_el$17, () => tr('filter.Advanced'), _el$18);
          return _el$16;
        })()];
      }
    }), null);
    _$insert(_el$13, _$createComponent(Drawer, {
      get open() {
        return adv();
      },
      onClose: () => setAdv(false),
      get children() {
        var _el$19 = _tmpl$7(),
          _el$20 = _el$19.firstChild,
          _el$21 = _el$20.firstChild,
          _el$22 = _el$21.nextSibling,
          _el$23 = _el$20.nextSibling,
          _el$24 = _el$23.nextSibling,
          _el$25 = _el$24.firstChild,
          _el$26 = _el$25.nextSibling;
        _$insert(_el$21, () => tr('filter.Advanced'));
        _el$22.$$click = () => setAdv(false);
        _$insert(_el$23, _$createComponent(For, {
          get each() {
            return m.filterItems();
          },
          children: item => _$createComponent(FilterControl, {
            item: item
          })
        }));
        _el$25.$$click = () => m.clearFilters();
        _$insert(_el$25, () => tr('filter.Clear'));
        _el$26.$$click = () => setAdv(false);
        return _el$19;
      }
    }), null);
    _$effect(() => _el$14.classList.toggle("info", !!(count() > 0)));
    return _el$13;
  })();
}

/** The active-filter chips row (rendered only when something is set). */
export function FilterChips() {
  const {
    module: m,
    tr
  } = useWorkflow();
  const label = ({
    item,
    value
  }) => {
    if (item.kind === 'range') return `${tr(item.key)}: ${value.from || '…'} – ${value.to || '…'}`;
    if (item.key === 'state') return `${tr(item.key)}: ${tr(`state.${value}`)}`;
    if (item.key === 'mine') return tr('filter.Mine');
    return `${tr(item.key)}: ${value}`;
  };
  return _$createComponent(Show, {
    get when() {
      return m.activeFilters().length > 0;
    },
    get children() {
      var _el$27 = _tmpl$9(),
        _el$28 = _el$27.firstChild;
      _$insert(_el$27, _$createComponent(For, {
        get each() {
          return m.activeFilters();
        },
        children: active => (() => {
          var _el$29 = _tmpl$0(),
            _el$30 = _el$29.firstChild;
          _$insert(_el$29, () => label(active), _el$30);
          _el$30.$$click = () => m.setFilter(active.item.key, undefined);
          return _el$29;
        })()
      }), _el$28);
      _el$28.$$click = () => m.clearFilters();
      _$insert(_el$28, () => tr('filter.Clear'));
      return _el$27;
    }
  });
}
_$delegateEvents(["click"]);